import PropTypes from 'prop-types';
// material-ui
import { useColorScheme } from '@mui/material/styles';

// third-party
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark, a11yLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';

// ==============================|| CODE HIGHLIGHTER ||============================== //

export default function SyntaxHighlight({ children, ...others }) {
  const { colorScheme } = useColorScheme();

  return (
    <SyntaxHighlighter
      language="javascript"
      showLineNumbers
      style={colorScheme === 'dark' ? a11yLight : a11yDark}
      {...others}
    >
      {children}
    </SyntaxHighlighter>
  );
}

SyntaxHighlight.propTypes = { children: PropTypes.string };
